export const sitemap = [
  {
    label: "UtahData (Home)",
    path: "/",
    children: [
      {
        label: "Utah Verticals",
        path: "/verticals",
        children: [
          { label: "Manufacturing", path: "/verticals/manufacturing" },
          { label: "Information", path: "/verticals/information" },
          {
            label: "Engineering & Technology",
            path: "/verticals/engineering-and-technology",
          },
          { label: "Food Industry", path: "/verticals/food" },
          { label: "Aerospace", path: "/verticals/aerospace" },
          {
            label: "BFM (Business Finance Marketing)",
            path: "/verticals/business-finance-marketing",
          },
        ],
      },
      {
        label: "Utah At a Glance",
        path: "/utah-at-a-glance",
        children: [
          {
            label: "Charging Stations",
            path: "/utah-at-a-glance/charging-stations",
          },
          { label: "Utah Housing", path: "/utah-at-a-glance/utah-housing" },
          { label: "Utah Counties", path: "/utah-at-a-glance/utah-counties" },
          { label: "Utah State", path: "/utah-at-a-glance/utah-state" },
          {
            label: "Utah Voters Count",
            path: "/utah-at-a-glance/utah-voters-count",
          },
          {
            label: "Utah Research Centers",
            path: "/utah-at-a-glance/utah-research",
          },
          { label: "Utah Mines", path: "/utah-at-a-glance/utah-mines" },
          { label: "Utah Libraries", path: "/utah-at-a-glance/utah-libraries" },
          { label: "Demographics", path: "/utah-at-a-glance/demographics" },
          { label: "Jobs", path: "/utah-at-a-glance/jobs" },
          {
            label: "Unemployment Rate",
            path: "/utah-at-a-glance/unemployment-rate",
          },
          { label: "Geothermal", path: "/utah-at-a-glance/geothermal" },
          { label: "Airports", path: "/utah-at-a-glance/airports" },
          { label: "MLM", path: "/utah-at-a-glance/mlm" },
          { label: "Hospital", path: "/utah-at-a-glance/hospitals" },
          { label: "Air Quality", path: "/utah-at-a-glance/air-quality" },
          { label: "Tax", path: "/utah-at-a-glance/taxes" },
          { label: "Zipcode", path: "/utah-at-a-glance/zipcodes" },
          { label: "Finance", path: "/utah-at-a-glance/finance" },
          {
            label: "Education & Resources",
            path: "/utah-at-a-glance/universities-and-schools",
            children: [
              {
                label: "Utah Universities",
                path: "/utah-at-a-glance/universities-and-schools/utah-universities",
              },
              {
                label: "Utah Schools",
                path: "/utah-at-a-glance/universities-and-schools/utah-schools",
              },
            ],
          },
          { label: "Utah Cities", path: "/utah-at-a-glance/utah-cities" },
          {
            label: "Culture",
            path: "/utah-at-a-glance/culture",
            children: [
              {
                label: "Religious",
                path: "/utah-at-a-glance/culture/religious",
              },
              { label: "History", path: "/utah-at-a-glance/culture/history" },
              { label: "Festival", path: "/utah-at-a-glance/culture/festival" },
            ],
          },
          {
            label: "Places",
            path: "/utah-at-a-glance/places",
            children: [
              {
                label: "Utah State Parks",
                path: "/utah-at-a-glance/utah-places-to-visit/utah-stateparks",
              },
              {
                label: "Utah National Parks",
                path: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks",
              },
              {
                label: "National Forests",
                path: "/utah-at-a-glance/utah-places-to-visit/national-forests",
              },
              {
                label: "National Monuments",
                path: "/utah-at-a-glance/utah-places-to-visit/national-monument",
              },
              {
                label: "Wildlife Refuges",
                path: "/utah-at-a-glance/utah-places-to-visit/national-wildlife-refuges",
              },
              {
                label: "Recreation Areas",
                path: "/utah-at-a-glance/utah-places-to-visit/national-recreation-area",
              },
              {
                label: "Historic Sites",
                path: "/utah-at-a-glance/utah-places-to-visit/national-historic-site",
              },
              {
                label: "Forest Services",
                path: "/utah-at-a-glance/utah-places-to-visit/national-forest-services",
              },
              {
                label: "Land & Wilderness",
                path: "/utah-at-a-glance/utah-places-to-visit/land-management-wilderness",
              },
              {
                label: "National Parks Details",
                path: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks",
                children: [
                  {
                    label: "Arches",
                    path: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/arches",
                  },
                  {
                    label: "Bryce Canyon",
                    path: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/bryce-canyon",
                  },
                  {
                    label: "Canyonland",
                    path: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/canyonland",
                  },
                  {
                    label: "Capitol Reef",
                    path: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/capitolreef",
                  },
                  {
                    label: "Zion",
                    path: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/zion",
                  },
                ],
              },
              {
                label: "Places to Visit",
                path: "/utah-at-a-glance/places-to-visit",
              },
            ],
          },
          { label: "Governor", path: "/utah-at-a-glance/utah-governor" },
          { label: "Agencies", path: "/utah-at-a-glance/agencies" },
          { label: "Sports", path: "/utah-at-a-glance/sports" },
          { label: "Adventure", path: "/utah-at-a-glance/adventure" },
          { label: "Airforce", path: "/utah-at-a-glance/airforce" },
        ],
      },
      {
        label: "Other Pages",
        path: "",
        children: [
          { label: "Login", path: "/login" },
          { label: "About", path: "/about" },
          { label: "Privacy Policy", path: "/privacy-policy" },
          { label: "Contact Us", path: "/contact-us" },
          { label: "Gallery", path: "/gallery" },
          { label: "KCG", path: "/kcg" },
          { label: "Ask Betsy AI", path: "/betsy" },
          { label: "Search Betsy AI", path: "/search" },
          { label: "Naics", path: "/get-naics" },
          { label: "Copyright", path: "/copyright" },
          { label: "WIP", path: "/wip" },
          { label: "Sitemap", path: "/sitemap" },
        ],
      },
    ],
  },
];

